module.exports = __webpack_public_path__ + "img/positive_main.618d5231.png";